import { render, staticRenderFns } from "./CreditNote.vue?vue&type=template&id=68c0cb91"
import script from "./CreditNote.vue?vue&type=script&lang=js"
export * from "./CreditNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports